import { baseURL } from './http.js';
import request from './request.js';


export default {
  getUserList: item => request(baseURL).post('/cUser/list', item),
  getUserListAll: item => request(baseURL).post('/cUser/listAll', item),
  createUser: item => request(baseURL).post('/cUser/create', item),
  updateUser: item => request(baseURL).post('/cUser/update', item),
  batchEnableUser: item => request(baseURL).post('/cUser/batchEnable', item),
  batchDisableUser: item => request(baseURL).post('/cUser/batchDisable', item),
  deleteByIdsUser: item => request(baseURL).post('/cUser/deleteByIds', item),
  getUser: val => request(baseURL).get(`/cUser/get?id=${val}`),
  cleanCache: item => request(baseURL).post('/cUser/cleanCache', item),
  cleanSupplierCache: item => request(baseURL).post('/supplier/cleanCache', item),
  enable: item => request(baseURL).post('/cUser/batchEnable', item),
  disable: item => request(baseURL).post('/cUser/batchDisable', item),
  delete: item => request(baseURL).post('/cUser/deleteByIds', item),
  getRoleList: () => request(baseURL).get(`/cUser/roleList`),
};